import { inject, Injectable, signal } from '@angular/core';
import { ToasterService } from './toaster.service';

export type MayBe<T> = T | null | undefined;

@Injectable({ providedIn: 'root' })
export class NetworkStatusService {
  private toaster = inject(ToasterService);

  public isOnline = signal(navigator.onLine);
  public isSlow = signal(false);

  constructor() {
    const conn = (navigator as any).connection;

    const updateStatus = () => {
      this.isOnline.set(navigator.onLine);
      this.isSlow.set(navigator.onLine && conn && (conn.downlink < 1.45 || conn.rtt > 600));

      setTimeout(() => {
        if (!this.isOnline()) {
          this.toaster.warning('You’re offline. Please reconnect and try again!');
        } else if (this.isSlow()) {
          this.toaster.warning('Your connection seems slow');
        }
      }, 0);
    };

    conn?.addEventListener('change', updateStatus);
    // window.addEventListener('offline', updateStatus);
    // window.addEventListener('online', updateStatus);

    // Initial check
    updateStatus();
  }

  ngOnDestroy() {
    const conn = (navigator as any).connection;

    // Remove listeners using the same function reference
    conn?.removeEventListener('change', () => {});
  }
}

// import { inject, Injectable, NgZone, signal } from '@angular/core';
// import { ToasterService } from './toaster.service';

// @Injectable({ providedIn: 'root' })
// export class NetworkStatusService {
//   private zone = inject(NgZone);
//   private toasterService = inject(ToasterService);

//   public isOnline = signal<boolean>(navigator.onLine);
//   public isSlow = signal<boolean>(false);

//   constructor() {
//     window.addEventListener('online', () => {
//       this.zone.run(() => {
//         // this.isOnline.set(true);
//       });
//     });

//     window.addEventListener('offline', () => {
//       this.zone.run(() => {
//         // this.isOnline.set(false);
//         // document.body.style.pointerEvents = 'none';
//         this.toasterService.warning(
//           'You’re offline. Please reconnect to the internet and try again!',
//         );
//       });
//     });

//     this.monitorConnectionType();
//   }

//   private monitorConnectionType() {
//     const connection =
//       (navigator as any).connection ||
//       (navigator as any).mozConnection ||
//       (navigator as any).webkitConnection;

//     if (connection) {
//       const updateConnectionStatus = () => {
//         const effectiveType = connection.effectiveType;
//         const isSlow = ['slow-2g', '2g', '3g'].includes(effectiveType);

//         this.zone.run(() => {
//           // this.isSlow.set(isSlow);
//           // document.body.style.pointerEvents = isSlow ? 'none' : 'auto';
//           isSlow && this.toasterService.warning('Your connection seems slow');
//         });
//       };

//       connection.addEventListener('change', updateConnectionStatus);
//       updateConnectionStatus();
//     }
//   }
// }
